export const FLEXIBLE_REPORTING_TRIAL_TEXT =
  'Explore the new Flexible Reporting tool for extended cuts of data. Now available for trial use.';
